import mod from "-!../../node_modules/style-loader/index.js!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./phone.vue?vue&type=style&index=0&lang=css&"; export default mod; export * from "-!../../node_modules/style-loader/index.js!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./phone.vue?vue&type=style&index=0&lang=css&"


//////////////////
// WEBPACK FOOTER
// ./ClientApp/shared/phone.vue?vue&type=style&index=0&lang=css&
// module id = 28
// module chunks = 2 5